export enum ErrorCodes {
  ZERO_WEIGHT_ORDER_PRESENT = "ZERO_WEIGHT_ORDER_PRESENT",
  // batch not created (timeout, throttling), all orders freed: a retry can work
  BATCH_ATTACH_FAILED = "BATCH_ATTACH_FAILED",
  // batch not created as some orders cannot be in a batch, all orders freed
  BATCH_ORDERS_NOT_ELIGIBLE = "BATCH_ORDERS_NOT_ELIGIBLE",
  // batch not created and the orders could not all be freed: manual clean up needed
  BATCH_ROLLBACK_FAILED = "BATCH_ROLLBACK_FAILED",
}
